/**
 * Who runs the app and the current privacy notice (DPDP Act, 2023). Bump NOTICE_VERSION when the
 * notice changes materially: every player sees the welcome notice again and re-confirms.
 */
export const LEGAL = {
  fiduciary: 'SolveMyBizz',
  contactEmail: 'privacy@solvemybizz.org',
  effectiveDate: '14 October 2026',
  noticeVersion: '2026-10-14',
  minimumAge: 18,
  /** Ended tables and their match records are deleted this long after the table ends. */
  gameDataRetentionDays: 30,
} as const;
